import React from 'react'

import { Box, Container, Typography } from '@material-ui/core'

import Carousel from 'artkive/components/Carousel'
import Image from 'artkive/components/Image'
import ContainedSection from 'artkive/components/PageSections/ContainedSection'
import HowItWorks, { HowItWorksButton } from 'artkive/components/PageSections/HowItWorks'
import DigitalStorage from 'artkive/components/sections/DigitalStorage'
import GetStartedWithBox from 'artkive/components/sections/GetStartedWithBox'
import ProductsCarousel from 'artkive/components/sections/ProductsCarousel'
import Social from 'artkive/components/Social'
import { TrackButton } from 'artkive/components/Tracker'
import { GET_BOX_CLICK } from 'artkive/constants/tracker/mainNavigation'
import withApp from 'artkive/hoc/withApp'
import useResponsive from 'artkive/hooks/useResponsive'
import useSale from 'artkive/hooks/useSale'
import { defaultHowItWorks } from 'artkive/stores/ecom/constants/data'
import theme from 'artkive/utils/theme'

import BrushStrokes from 'images/ecom/brand/brushStrokes.svg'
import Bubbles from 'images/ecom/bubbles.svg'

import AsFeaturedOnSection from './AsFeaturedOnSection'
import GetStartedFooter from './GetStartedFooter'
import HeroSection from './HeroSection'
import { PRODUCTS, SLIDES } from './Home.constants'
import {
  BrushStrokesIcon,
  BubbleIcon,
  GridContainer,
  GridItem,
  ProductsContainer,
  ProductsContainerWrapper,
  Wrapper,
} from './Home.style'
import ProductItem from './ProductItem'
import SaleStripe from './SaleStripe'
import SeeUsInMotionSection from './SeeUsInMotionSection'
import TrustIndexReviews from './TrustIndexReviews'

const Home = () => {
  const { isMobile, isSmDesktop, isNewLgDesktop } = useResponsive()
  const { isSale, name, priceLabel, boxCheckoutUrl } = useSale()

  return (
    <Wrapper>
      <HeroSection />
      {isSale && (
        <>
          <SaleStripe message={`${name} – Artkive Box just ${priceLabel}`} />
          <GetStartedWithBox />
        </>
      )}
      <ProductsContainerWrapper py={isMobile ? 8 : theme.spacings.section}>
        <ProductsContainer>
          <Box mb={isMobile ? 6 : 8} textAlign='center'>
            <Typography variant='h2'>Our Products</Typography>
          </Box>
          <GridContainer container spacing={isMobile ? 0 : isSmDesktop ? 2 : isNewLgDesktop ? 4 : 7}>
            {PRODUCTS.map((product, index) => (
              <GridItem key={product.id} xs={12} md={12 / PRODUCTS.length} item>
                {isMobile ? (
                  <>{index ? <BubbleIcon src={Bubbles} /> : <BrushStrokesIcon src={BrushStrokes} />}</>
                ) : (
                  <>
                    {!index && <BubbleIcon src={Bubbles} />}
                    {index === PRODUCTS.length - 1 && <BrushStrokesIcon src={BrushStrokes} />}
                  </>
                )}
                <ProductItem {...product} />
              </GridItem>
            ))}
          </GridContainer>
        </ProductsContainer>
      </ProductsContainerWrapper>
      <HowItWorks steps={defaultHowItWorks} title='How It Works' variant='image'>
        <HowItWorksButton
          title='Get My Box'
          href={boxCheckoutUrl}
          trackerEvent={GET_BOX_CLICK}
          trackerOptions={{ section: 'home_how_it_works' }}
        />
      </HowItWorks>
      {!isSale && <GetStartedWithBox />}
      <DigitalStorage bgcolor={isMobile ? undefined : theme.colors.white.main} />
      <ContainedSection
        disableGutters
        title={
          <Typography variant='h2' align='center'>
            500,000 families, 20 million pieces of art and counting
          </Typography>
        }
      >
        <Box px={1}>
          <TrustIndexReviews />
        </Box>
        <Box justifyContent='center' display='flex' mt={isMobile ? 6 : 8}>
          <TrackButton
            color='primary'
            variant='contained'
            href={boxCheckoutUrl}
            trackerEvent={GET_BOX_CLICK}
            trackerOptions={{
              section: 'home_how_it_works',
            }}
            size='large'
          >
            Get My Box
          </TrackButton>
        </Box>
      </ContainedSection>
      <Container disableGutters={isMobile}>
        <Box position='relative' my={10} mx={4}>
          <Box position='absolute' top={isMobile ? '-50px' : '-50px'} left={isMobile ? '-50px' : '-50px'} zIndex={1}>
            <Image src={BrushStrokes} style={{ width: '50px' }} />
          </Box>
          <Carousel isMobile={isMobile} slides={SLIDES} />
        </Box>
      </Container>
      <AsFeaturedOnSection />
      <SeeUsInMotionSection />
      <Container>
        <Box mt={12}>
          <Typography align='center' variant='h2'>
            Explore Other Kive Products
          </Typography>
        </Box>
        <ProductsCarousel />
      </Container>
      <Social />
      <GetStartedFooter />
    </Wrapper>
  )
}

export default withApp(Home)
